import { graphql } from "../generated";

export const MUTATE_CREATE_POST = graphql(`
  mutation MutateCreatePost(
    $threadId: Int
    $animationId: Int
    $text: String!
    $title: String
    # $lock: Boolean
    $type: ThreadType!
    $endDate: Date
  ) {
    createPost(
      threadId: $threadId
      animationId: $animationId
      text: $text
      title: $title
      # lock: $lock
      type: $type
      endDate: $endDate
    ) {
      id
      userId
      title
      type
      createdAt
      updatedAt
      locked
      pinned
      animationId
      animationUrl
      posts {
        id
        threadId
        createdAt
        user {
          id
          theme {
            post
          }
        }
      }
    }
  }
`);
